import { render } from "./DownloadInvoices.vue?vue&type=template&id=9b98cf8e&scoped=true"
import script from "./DownloadInvoices.vue?vue&type=script&lang=js"
export * from "./DownloadInvoices.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\Ltd24ore-client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9b98cf8e"]])

export default __exports__